<template>
  <v-dialog :value="value" max-width="1100px" @input="close">
    <v-card v-if="channel">
      <v-card-title
        class="headline primary lighten-1 white--text justify-space-between"
      >
        {{ channel.name }} parsing outcomes
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-alert text color="red" type="error" v-if="errorMsg">
          {{ errorMsg }}
        </v-alert>
        <v-row v-if="outcomes" class="align-center">
          <v-col cols="12" md="9" class="black--text">
            <div>
              Download method:
              <b>{{ outcomes.method.downloadMethodName }}</b>
              <span
                v-if="outcomes.method.downloadMethodPinned"
                class="grey--text"
              >
                (assigned by hand)
              </span>
              <span
                v-else-if="outcomes.method.downloadMethodAuto"
                class="grey--text"
              >
                (automatic, autoswitch: {{ outcomes.autoswitchMode }})
              </span>
            </div>
            <div v-if="outcomes.method.nextHttpProbe">
              {{
                outcomes.method.httpProbeDue
                  ? "Http probe due since"
                  : "Next http probe"
              }}: {{ outcomes.method.nextHttpProbe }}
              <span
                v-if="
                  outcomes.method.httpProbeDue &&
                  outcomes.autoswitchMode !== 'on'
                "
                class="grey--text"
              >
                (probes run only with autoswitch "on")
              </span>
            </div>
            <div v-if="outcomes.method.methodFailStreak">
              {{ streakLabel }}: {{ outcomes.method.methodFailStreak }}
            </div>
            <div v-if="outcomes.method.linksOutcome">
              Last links run:
              <span :class="kindTextClass(outcomes.method.linksOutcomeKind)">
                {{ outcomes.method.linksOutcome }}
              </span>
              <span class="grey--text">{{
                outcomes.method.linksCheckedAt
              }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="days"
              :items="periods"
              item-text="label"
              item-value="value"
              label="Period"
              dense
              @change="fetchOutcomes"
            ></v-select>
          </v-col>
        </v-row>
        <v-progress-linear v-if="isLoading" indeterminate></v-progress-linear>
        <outcomes-tables
          v-if="outcomes && !isLoading"
          :outcomes="outcomes"
        ></outcomes-tables>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { FETCH_CHANNEL_OUTCOMES } from "@/store/modules/channel/actions";
import OutcomesTables from "./OutcomesTables";
import { KIND_COLORS } from "./OutcomeChips";

export default {
  name: "ChannelOutcomesDialog",
  components: { OutcomesTables },
  props: {
    value: { type: Boolean, default: false },
    channel: { type: Object, default: null },
  },
  data() {
    return {
      days: 14,
      periods: [
        { label: "Today", value: 1 },
        { label: "7 days", value: 7 },
        { label: "14 days", value: 14 },
        { label: "30 days", value: 30 },
        { label: "90 days", value: 90 },
      ],
      outcomes: null,
      isLoading: false,
      errorMsg: "",
    };
  },
  computed: {
    streakLabel() {
      return this.outcomes.method.downloadMethod === 2
        ? "Failed http probes in a row"
        : "Blocked links runs in a row";
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.fetchOutcomes();
      }
    },
  },
  methods: {
    kindColor(kind) {
      return KIND_COLORS[kind] || "grey";
    },
    kindTextClass(kind) {
      return `${this.kindColor(kind)}--text`;
    },
    fetchOutcomes() {
      const vm = this;
      vm.isLoading = true;
      vm.errorMsg = "";
      vm.$store
        .dispatch(`channels/${FETCH_CHANNEL_OUTCOMES}`, {
          id: vm.channel.id,
          days: vm.days,
        })
        .then(
          (data) => {
            vm.outcomes = data.data;
            vm.isLoading = false;
          },
          (error) => {
            vm.errorMsg = error;
            vm.isLoading = false;
          }
        );
    },
    close() {
      this.outcomes = null;
      this.$emit("input", false);
    },
  },
};
</script>
